/* RealBio — capa de movimiento.
   Sin librerías externas: ni Lenis ni GSAP. Todo se apoya en CSS y en un
   rAF mínimo, para no cargar 40 KB de JS en un sitio que va a recibir
   tráfico de anuncios desde móvil.

   Regla transversal: si el usuario pide menos movimiento, no se hace nada. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* ---------------------------------------------------------------------
     1. Revelado al entrar en pantalla.
     Failsafe obligatorio: en webviews de anuncios y paneles de vista previa
     el IntersectionObserver no dispara y la página se quedaría en blanco.
     --------------------------------------------------------------------- */
  function revelar() {
    var sel = '.rb-section__head, .rb-card, .rb-cat__card, .rb-verify__item,'
            + ' .rb-coa__text, .rb-coa__media, .rb-prod__media, .rb-prod__info,'
            // secciones añadidas después: ruta guiada, tabla, FAQ, vídeo y
            // tarjetas de artículo. Comparten el mismo revelado en vez de
            // llevar cada una el suyo.
            + ' .rb-ruta__paso, .rb-tr__tabla tbody tr, .rb-faq__i,'
            + ' .rb-vid__texto, .rb-vid__player, .rb-article-card, .rb-acc__i';
    var items = Array.prototype.slice.call(document.querySelectorAll(sel));
    if (!items.length) return;

    items.forEach(function (el, i) {
      el.classList.add('rb-in');
      // Escalonado suave dentro de cada grupo, tope 6 para no hacer esperar
      el.style.setProperty('--rb-delay', (Math.min(i, 6) * 60) + 'ms');
    });

    function mostrar(el) { el.classList.add('rb-in--on'); }

    if (!('IntersectionObserver' in window)) { items.forEach(mostrar); return; }

    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { mostrar(e.target); o.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    items.forEach(function (el) { obs.observe(el); });

    window.setTimeout(function () {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) mostrar(el);
      });
    }, 1400);
  }

  /* ---------------------------------------------------------------------
     2. Paralaje muy contenido en el hero.
     Un 12% de desplazamiento, no más: en registro clínico el movimiento
     tiene que notarse sin que se vea.
     --------------------------------------------------------------------- */
  function parallax() {
    var img = document.querySelector('.rb-hero__img');
    if (!img) return;
    var hero = img.closest('.rb-hero');
    var media = img.closest('.rb-hero__media');
    var pendiente = false;

    function pintar() {
      // Si el vídeo ambiental ya está reproduciéndose, la foto quedó en
      // opacity:0 detrás — seguir transformándola es trabajo invisible.
      if (media && media.classList.contains('is-playing')) { pendiente = false; return; }
      var r = hero.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var avance = Math.min(1, Math.max(0, -r.top / (r.height || 1)));
        img.style.transform = 'translate3d(0,' + (avance * 12) + '%,0) scale(1.12)';
      }
      pendiente = false;
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); }
    }, { passive: true });
    pintar();
  }

  /* ---------------------------------------------------------------------
     3b. Vídeo ambiental (rb-proceso): banner en bucle, silenciado, sin botón
     de play — B-roll de humor, no la pieza narrada de rb-video.liquid. Vive
     aquí (no en rb-theme.js) a propósito: al estar dentro de esta IIFE hereda
     gratis el corte de arriba — si el usuario pide menos movimiento, esta
     función jamás se ejecuta y el <video> nunca se crea; el póster se queda
     fijo. Mismo patrón de carga diferida que el resto del sitio: nada de
     autoplay/src en el HTML, el navegador no toca el .mp4 hasta que la caja
     entra en pantalla (o está a punto de hacerlo).
     --------------------------------------------------------------------- */
  function videoAmbiental() {
    var cajas = document.querySelectorAll('[data-rb-ambient-video]');
    if (!cajas.length) return;

    function cargar(caja) {
      if (caja.dataset.loaded) return;
      caja.dataset.loaded = '1';
      var src = caja.dataset.src;
      if (!src) return;

      var v = document.createElement('video');
      v.muted = true;
      v.setAttribute('muted', ''); // Safari/iOS a veces exige el atributo, no solo la propiedad
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.preload = 'auto';
      v.src = src;

      caja.appendChild(v);
      caja.classList.add('is-playing');
      v.play().catch(function () {
        // Si el navegador bloquea la reproducción, el póster se queda de fondo.
        caja.classList.remove('is-playing');
      });
    }

    if (!('IntersectionObserver' in window)) {
      // Red de seguridad: navegadores de automatización y algunos webviews
      // no disparan el observer.
      cajas.forEach(cargar);
      return;
    }

    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { cargar(entry.target); o.unobserve(entry.target); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    cajas.forEach(function (caja) { obs.observe(caja); });

    // Red de seguridad por scroll, igual que en revelar().
    window.addEventListener('scroll', function () {
      cajas.forEach(function (caja) {
        var r = caja.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2 && r.bottom > 0) cargar(caja);
      });
    }, { passive: true });
  }

  /* ---------------------------------------------------------------------
     3. Anclas con desplazamiento suave, respetando la cabecera fija.
     --------------------------------------------------------------------- */
  function anclas() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var destino = document.getElementById(id);
      if (!destino) return;
      e.preventDefault();
      var y = destino.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
      destino.setAttribute('tabindex', '-1');
      destino.focus({ preventScroll: true });
    });
  }

  function init() { revelar(); parallax(); anclas(); videoAmbiental(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
})();
